import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const ProductListing = (props) => {
    const { product, formatMoney, handleAddToCart, handleRemoveFromCart, isProductInCart, setProductToView, toggleProductDetail, getActiveImageIndex, setProductImageIndex, handlePrevImage, handleNextImage } = props;

    const productImages = product.images?.length > 0 ? product.images : null;
    const firstFiveProductImages = productImages?.slice(0, 5) || [];
    const activeImageIndex = getActiveImageIndex(product.id);
    const activeImage = productImages?.length > 0 ? (productImages[activeImageIndex] || productImages[0]) : 0;
    return (
        <div className='product-listing' key={product.id}>
            <div className='product-listing__row'>
                <div className='product-listing__title'>
                    <strong>{product.title}</strong>
                </div>
                <div className='product-listing__category'>{product.category}</div>
            </div>
            <div className='product-listing__image-container'>
                {productImages && productImages?.length > 0 && (
                    <>
                        <div className='product-listing__image-navigation'>
                            {productImages?.length > 1 &&
                                <IconButton
                                    size="small"
                                    onClick={() => handlePrevImage(product.id, productImages.length)}
                                    disabled={productImages.length <= 1}
                                >
                                    <ArrowBackIosNewIcon fontSize="small" />
                                </IconButton>}

                            <img
                                style={{
                                    maxHeight: '200px',
                                    maxWidth: '80%',
                                    objectFit: 'contain'
                                }}
                                src={activeImage?.url + '&width=258'}
                                alt={activeImage?.altText || product.title}
                            />
                            {productImages?.length > 1 &&
                                <IconButton
                                    size="small"
                                    onClick={() => handleNextImage(product.id, productImages.length)}
                                    disabled={productImages.length <= 1}
                                >
                                    <ArrowForwardIosIcon fontSize="small" />
                                </IconButton>}
                        </div>

                        <div className='product-listing__image-thumbnails'>
                            {firstFiveProductImages.map((image, index) => (
                                <button
                                    key={`${product.id}-${image.id || index}`}
                                    type="button"
                                    onClick={() => setProductImageIndex(product.id, index)}
                                    className={index === activeImageIndex ? 'product-listing__thumbnail active' : 'product-listing__thumbnail'}
                                >
                                    <img src={image.url +'&width=42&height=42'} alt={image.altText || product.title}/>
                                </button>
                            ))}
                        </div>
                    </>)}
            </div>
            <div className='product-listing__bottom-section'>
                <div className='product-listing__price'><strong>{formatMoney(product.price, product.currencyCode)}</strong></div>
                <Button
                    className='product-listing__view-btn'
                    style={{ width: '80%', margin: '15px' }}
                    onClick={() => { setProductToView(product); toggleProductDetail(); }}
                >
                    View Product
                </Button>

                <Button
                    className='product-listing__add-to-cart-btn'
                    color={isProductInCart(product.variantId) ? 'error' : 'primary'}
                    variant="outlined"
                    onClick={() => isProductInCart(product.variantId)
                        ? handleRemoveFromCart(product)
                        : handleAddToCart(product)}
                >
                    {isProductInCart(product.variantId) ? 'Remove From Cart' : 'Add To Cart'}
                </Button>
            </div>

        </div>
    )
};

export default ProductListing;